var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useCallback, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import { Ripple } from 'primereact/ripple';

const AppSubmenu = props => {

    const [activeIndex, setActiveIndex] = useState(null);

    const onMenuItemClick = (event, item, index) => {
        if (item.disabled) {
            event.preventDefault();
            return;
        }
        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
            event.preventDefault();
        }
        if (item.items) {
            event.preventDefault();
        }
        if (props.root) {
            props.onRootMenuitemClick({
                originalEvent: event
            });
        }
        if (item.items) {
            setActiveIndex(index === activeIndex ? null : index);
        }

        props.onMenuitemClick({
            originalEvent: event,
            item: item
        });
    };

    const onMenuItemMouseEnter = index => {
        if (props.root && props.menuActive && props.menuMode === "slim" && !isMobile()) {
            setActiveIndex(index);
        }
    };

    const visible = item => {
        return typeof item.visible === "function" ? item.visible() : item.visible !== false;
    };

    const isMobile = () => {
        return window.innerWidth <= 991;
    };

    const isSlim = useCallback(() => {
        return props.menuMode === 'slim';
    }, [props.menuMode]);

    const getLink = (item, index) => {
        const menuitemIconClassName = classNames('layout-menuitem-icon', item.icon);
        const content = React.createElement(
            React.Fragment,
            null,
            React.createElement('i', { className: menuitemIconClassName }),
            React.createElement(
                'span',
                { className: 'layout-menuitem-text', id: !!item.to ? 'submenu-item' : '' },
                item.label
            ),
            item.items && React.createElement('i', { className: 'pi pi-fw pi-angle-down layout-submenu-toggler' }),
            React.createElement(Ripple, null)
        );
        const commonLinkProps = {
            'style': item.style,
            'className': classNames(item.className, 'p-ripple', { 'p-disabled': item.disabled, 'p-link': !item.to }),
            'target': item.target,
            'onClick': e => onMenuItemClick(e, item, index),
            'onMouseEnter': () => onMenuItemMouseEnter(index)
        };

        if (item.url) {
            return React.createElement(
                'a',
                _extends({ href: item.url, rel: 'noopener noreferrer' }, commonLinkProps),
                content
            );
        } else if (!item.to) {
            return React.createElement(
                'button',
                _extends({ type: 'button' }, commonLinkProps),
                content
            );
        }

        return React.createElement(
            NavLink,
            _extends({ to: item.to, exact: true, activeClassName: 'active-route' }, commonLinkProps),
            content
        );
    };

    const getIcon = item => {
        const menuitemIconClassName = classNames('layout-menuitem-icon', item.icon);

        return React.createElement('span', { className: menuitemIconClassName });
    };

    const isMenuActive = (item, index) => {
        return item.items && (props.root && (!isSlim() || isSlim() && (props.mobileMenuActive || activeIndex !== null)) ? true : activeIndex === index);
    };

    const getItems = () => {
        const transitionTimeout = props.mobileMenuActive ? 0 : isSlim() && props.root ? { enter: 400, exit: 400 } : props.root ? 0 : { enter: 1000, exit: 450 };
        return props.items.map((item, i) => {
            if (visible(item)) {
                if (!item.separator) {
                    const menuitemClassName = classNames({ 'layout-root-menuitem': props.root, 'active-menuitem': activeIndex === i && !item.disabled });
                    const link = getLink(item, i);
                    const icon = getIcon(item);
                    const rootMenuItem = props.root && React.createElement(
                        'div',
                        {
                            className: 'layout-root-menuitem',
                            style: { padding: "1rem 0.5rem", display: "flex", alignItems: "center", marginLeft: "0.5rem", gap: "1rem" }
                        },
                        icon,
                        React.createElement(
                            'div',
                            {
                                className: 'layout-menuitem-root-text',
                                style: { textTransform: "uppercase", color: "#FFF", padding: "0" }
                            },
                            item.label
                        )
                    );

                    return React.createElement(
                        'li',
                        { key: item.label || i, className: menuitemClassName, role: 'menuitem' },
                        link,
                        rootMenuItem,
                        React.createElement(
                            CSSTransition,
                            { classNames: 'layout-menu', timeout: transitionTimeout, 'in': isMenuActive(item, i), unmountOnExit: true },
                            React.createElement(AppSubmenu, { items: visible(item) && item.items, menuActive: props.menuActive, menuMode: props.menuMode, parentMenuItemActive: activeIndex === i, onMenuitemClick: props.onMenuitemClick })
                        )
                    );
                } else {
                    return React.createElement('li', { className: 'menu-separator', style: item.style, key: `separator${i}`, role: 'separator' });
                }
            }

            return null;
        });
    };

    useEffect(() => {
        if (!props.menuActive && isSlim()) {
            setActiveIndex(null);
        }
    }, [props.menuActive, isSlim]);

    if (!props.items) {
        return null;
    }

    const items = getItems();
    return React.createElement(
        'ul',
        { className: 'layout-menu', role: 'menu', style: { paddingInline: "0.5rem" } },
        items
    );
};

export default AppSubmenu;